import { render, staticRenderFns } from "./Metodo.vue?vue&type=template&id=1241f773&scoped=true&"
import script from "./Metodo.vue?vue&type=script&lang=js&"
export * from "./Metodo.vue?vue&type=script&lang=js&"
import style0 from "./Metodo.vue?vue&type=style&index=0&id=1241f773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241f773",
  null
  
)

export default component.exports